import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import "./style/reset.css";
import axios from "axios";
import bridge from "./common/bridge";
import doImg from "./utils/doImg";
import apis from "./apis/index";
import "./utils/index";
import { Toast } from "vant";

Toast.setDefaultOptions("loading", {
	duration: 20000,
});
// import VConsole from "vconsole";
// const vConsole = new VConsole();
// Vue.use(vConsole);

Vue.prototype.$apis = apis;
Vue.prototype.$bridge = bridge;
Vue.prototype.$doImg = doImg;
// axios.defaults.baseURL = "/apis";
// 测试
// axios.defaults.baseURL = "http://58.210.88.98:10086/";
// 正式
// axios.defaults.baseURL = "https://ksappin.ksecard.cn:12601/";
axios.defaults.baseURL = "http://ksappin.ksecard.cn:12501/";

axios.defaults.withCredentials = true;

axios.interceptors.request.use(
	config => {
		if (
			config.data == "metacode=USERAGREEMENT" ||
			config.data == "metacode=PRIVACYPOLICY" ||
			config.url == "/appinteraction/appEdition/getAndroidBean" ||
			config.url == "/appinteraction/appEdition/getIosBean" ||
			config.url == "appapi/cmsInterface/getCmsInfo" ||
			config.url == "appinteraction/appInteraction/getInteractionShare" ||
			config.url == "/appapi/cmsInterface/getPlagueData" ||
			config.url == "appapi/branch/distributionList"
		) {
			return config;
		}

		// let token =
		// 	"Bearer" +
		// 	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsiY2l0eWlkZW50aXR5IiwiY2l0eXNoaWVsZGluZm8iLCJjaXR5dXNlcmluZm8iLCJjaXR5YXBwaW5mbyIsImNpdHlhcHBpbnRlcmFjdGlvbiIsImNpdHlpZGVudGl0eWNvZGUiXSwidXNlcl9uYW1lIjoie1widXNlcnR5cGVcIjoxLFwib2xkaWRcIjpcIjE4OTIyODAzXCIsXCJ1c2VyaWRcIjpcIjIxMDYwODE2NDIzMTkxMDJcIixcInVzZXJuYW1lXCI6XCIxNTA2MTExMDYxOFwifSIsInNjb3BlIjpbImNpdHl1c2VyaW5mbyIsImNpdHlhcHBpbmZvIiwiY2l0eWFwcGludGVyYWN0aW9uIiwiY2l0eWlkZW50aXR5IiwiY2l0eWlkZW50aXR5Y29kZSIsImNpdHlzaGllbGRpbmZvIl0sImV4cCI6MTY4MTk5NjM5NCwiYXV0aG9yaXRpZXMiOlsicDEiXSwianRpIjoiYTc4MDVhOGYtZGY2MC00YWNhLTg2N2UtYjNjZjZjZGE4NDYyIiwiY2xpZW50X2lkIjoia3NjaXR5bG9naW4ifQ.tRgYtr1xg-4bstK1PK-76GLSEEUpm7uH3lQXssTdpc0";
		let token = "bearer" + localStorage.getItem("token");

		config.headers.Authorization = token;
		return config;
	},
	error => {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// // http response 拦截器
// axios.interceptors.response.use(
//   response => {

//     return response;
//   },
//   error => {

//     if (error.response) {
//       // switch (error.response.status) {
//       //   case 401:
//       //     this.$store.commit('del_token');
//       //     router.replace({
//       //       path: '/login',
//       //       query: {
//       //         redirect: router.currentRoute.fullPath
//       //       } //登录成功后跳入浏览的当前页面
//       //     })
//       // }
//     }
//     return Promise.reject(error.response)
//   });

Vue.prototype.$axios = axios;
Vue.use(Vant);

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
});

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount("#app");
